import styled from "styled-components";

export const Container = styled.button`
  position: fixed;
  bottom: 32px;
  right: 24px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  width: 46px;
  height: 46px;

  background-color: ${({ theme: { colors } }) => colors.navy[700]};
  color: ${({ theme: { colors } }) => colors.white};
  border: none;
  border-radius: ${({ theme: { radii } }) => radii.pill};

  box-shadow: ${({ theme: { shadow } }) => shadow.md};

  opacity: ${({ active }) => (active ? 1 : 0)};
  visibility: ${({ active }) => (active ? "visible" : "hidden")};
  transform: ${({ active }) => (active ? "translateY(0)" : "translateY(16px)")};

  z-index: 9998;

  transition: opacity ${({ theme: { transition } }) => transition.base},
    transform ${({ theme: { transition } }) => transition.base},
    background-color ${({ theme: { transition } }) => transition.fast},
    visibility 0s linear ${({ active }) => (active ? "0s" : "0.24s")};

  &:hover {
    background-color: ${({ theme: { colors } }) => colors.navy[800]};
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;
